import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue800} from "assets/jss/main";

ItemName.propTypes = {
    label: PropTypes.string.isRequired
};

function ItemName({label,...props}) {
    return (
        <span style={{
            color: greyishBlue800,
            fontSize: '14px',
        }}>
            {label}
        </span>
    );
}

export default ItemName;
